import { WizardStepPage } from '../../WizardStepPage/view';
import { DeviceNameStepView } from '../../DeviceNameStepView/view';

export const GatewayMessageStepView = WizardStepPage.extend({
    template: '#tpl_gateway_message_step',
    stepNumberKey: 'mobile_sensors_wizard_step_two',
    stepTitleKey: 'mobile_sensors_gateway_plugged_in',
    nextStepViewClass: DeviceNameStepView,
    selectedManufacturer: null,

    templateHelpers: function () {
        return {
            ...GatewayMessageStepView.__super__.templateHelpers.apply(this, arguments),
            image_filename: 'gateway_plug.svg'
        };
    },

    displayNextStep: function () {
        $f.mobile.nav.show(DeviceNameStepView, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey,
            selectedManufacturer: this.selectedManufacturer
        });
    }
});
